module.exports = __webpack_public_path__ + "media/images/steps/png/235-curriculum-vitae-997b3269ae51417dbb32d9306000ccb8.png";